<template>
    <div>
        <p v-if="false">
            Mode
            <b-select v-model="mode" :options="[
                {value: 'prepared_request', text: 'Requête préparée'},
                {value: 'request', text: 'Requête'}
            ]" />
        </p>

        <div v-if="mode == 'prepared_request'">
            <p>Requête
                <b-select v-model="element" :options="list_prepared_requests" />
            </p>
        </div>
        <div v-if="mode == 'request'">
            <p>Requête
                <b-button style="padding:1px" variant="link" v-b-tooltip.hover title="Astuce : tapez url:nom_colonne pour envoyer le contenu de l'URL contenue dans cette colonne à ChatGPT."><i class="fas fa-info"></i></b-button>
                <textarea_plus ref="request" :columns="columns_data"></textarea_plus>
            </p>
            <p>Modèle
                <b-select v-model="model" :options="list_models" style="display:inline-block; width:auto; margin-right:6px;" />
                <b-button size="sm" variant="outline-secondary" @click="open_model_editor" v-b-tooltip.hover :title="model ? 'Modifier ce modèle' : 'Créer un nouveau modèle'">
                    <i :class="model ? 'fas fa-pen' : 'fas fa-plus'"></i>
                </b-button>
            </p>
        </div>

        <b-modal :id="'model_editor' + id" :title="model_editor_is_new ? 'Nouveau modèle' : 'Modifier le modèle'" @ok="save_model" ok-title="Enregistrer" cancel-title="Annuler">
            <b-form-group label="Nom du modèle">
                <b-input v-model="model_editor_name" :disabled="!model_editor_is_new" placeholder="ex: mon-modele-seo" />
            </b-form-group>
            <b-form-group label="Service">
                <b-select v-model="model_editor_service" :options="[
                    { value: 'chatgpt', text: 'ChatGPT' },
                    { value: 'perplexity', text: 'Perplexity' }
                ]" />
            </b-form-group>
            <b-form-group label="Modèle">
                <div class="d-flex align-items-center mb-1">
                    <b-input v-model="model_editor_version" :list="'model_editor_versions' + id" placeholder="ex: gpt-4.1, gpt-4o, o4-mini..." style="margin-right:6px;" />
                    <b-button size="sm" variant="outline-secondary" @click="fetch_available_models" :disabled="model_editor_loading_models" v-b-tooltip.hover title="Récupérer la liste des modèles disponibles">
                        <i v-if="model_editor_loading_models" class="fas fa-spinner fa-spin"></i>
                        <i v-else class="fas fa-sync"></i>
                    </b-button>
                </div>
                <datalist :id="'model_editor_versions' + id">
                    <option v-for="(m, idx) in model_editor_available_models" :key="idx" :value="m.value">{{ m.text }}</option>
                </datalist>
            </b-form-group>
            <div v-if="model_editor_saving" class="text-center"><i class="fas fa-spinner fa-spin"></i> Enregistrement...</div>
            <div v-if="model_editor_error" class="text-danger">{{ model_editor_error }}</div>
        </b-modal>

        <div v-show="!display.is_documents || !is_documents">
            <b>Schéma JSON de sortie</b>
            <b-checkbox v-model="has_json_schema" :disabled="display.web_search" @change="$event && (display.web_search = false)" style="display:inline; margin-left: 6px;"></b-checkbox>

            <div v-if="has_json_schema">
                <b-row class="mt-1">
                    <b-col :cols="4">Colonne contenant le schéma
                        <b-input v-model="json_schema_column" :list="'json_schema_col_' + id" placeholder="Nom de la colonne (optionnel)" />
                        <datalist :id="'json_schema_col_' + id">
                            <option v-for="(col, idx) in columns_data" :key="idx">{{ col }}</option>
                        </datalist>
                    </b-col>
                </b-row>
                <json_schema_editor v-show="!json_schema_column" ref="json_schema_editor" :show_start_array="true" :show_required="false"/>
            </div>
        </div>

        <p v-if="service == 'chatgpt'">
            <b>Recherche web</b>
            <b-checkbox v-model="display.web_search" :disabled="has_json_schema" @change="$event && (display.is_documents = false, has_json_schema = false)" style="display:inline; margin-left: 6px;"></b-checkbox>
            <div v-if="display.web_search" style="margin-top: 8px;">
                <b-row class="mb-2">
                    <b-col :cols="6">Domaines autorisés (whitelist) <b-button style="padding: 1px;" variant="link" v-b-tooltip.hover title="Un domaine par ligne, ex: monsite.com. Vous pouvez référencer une colonne avec ${data.maColonne} — la valeur peut être un domaine ou un JSON array de domaines."><i class="fas fa-info"></i></b-button>
                        <b-form-textarea v-model="web_search_allowed_domains" rows="3" placeholder="ex: exemple.com" />
                    </b-col>
                    <b-col :cols="6">Domaines bloqués (blacklist) <b-button style="padding: 1px;" variant="link" v-b-tooltip.hover title="Un domaine par ligne, ex: reddit.com. Vous pouvez référencer une colonne avec ${data.maColonne} — la valeur peut être un domaine ou un JSON array de domaines."><i class="fas fa-info"></i></b-button>
                        <b-form-textarea v-model="web_search_blocked_domains" rows="3" placeholder="ex: exemple.com" />
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="auto" class="d-flex align-items-center pr-1">Localisation :</b-col>
                    <b-col cols="3"><b-input v-model="web_search_location_city" placeholder="Ville (ex: Paris)" size="sm" /></b-col>
                    <b-col cols="2"><b-input v-model="web_search_location_country" placeholder="Pays (ex: FR)" size="sm" maxlength="2" /></b-col>
                </b-row>
                <b-row>
                    <b-col :cols="6">Colonne sources <b-button style="padding: 1px;" variant="link" v-b-tooltip.hover title="Colonne où stocker les URLs des sources trouvées (JSON array). Laisser vide pour ne pas récupérer."><i class="fas fa-info"></i></b-button>
                        <b-input v-model="web_search_column_sources" placeholder="ex: sources" size="sm" />
                    </b-col>
                    <b-col :cols="6">Colonne citations <b-button style="padding: 1px;" variant="link" v-b-tooltip.hover title="Colonne où stocker les citations avec titre et URL (JSON array d'objets {title, url}). Laisser vide pour ne pas récupérer."><i class="fas fa-info"></i></b-button>
                        <b-input v-model="web_search_column_citations" placeholder="ex: citations" size="sm" />
                    </b-col>
                </b-row>
                <b-row class="mt-2">
                    <b-col>
                        <b-checkbox v-model="web_search_strip_citations" style="display:inline" />
                        Ne pas inclure les marqueurs de citation dans la réponse
                        <b-button style="padding: 1px;" variant="link" v-b-tooltip.hover title="Supprime les références inline [n] du texte de réponse. Les sources restent disponibles dans la colonne citations si configurée."><i class="fas fa-info"></i></b-button>
                    </b-col>
                </b-row>
            </div>
        </p>

        <p><b>Paramètres complémentaires</b>
        
            <b-button
                v-b-modal="'params' + id"
                variant="link">
                <i class="fas fa-plus"></i>
            </b-button>

            <b-modal :id="'params' + id" ok-only title="Paramètres coomplémentaires">
                <p><b-checkbox style="display:inline" v-model="display.system" />Message système</p>
                <p><b-checkbox style="display:inline" v-model="display.get_column_system" />Récupérer le message système envoyé</p>                
                <p><b-checkbox style="display:inline" v-model="display.get_column_prompt" />Récupérer le prompt envoyé</p>
                <p><b-checkbox v-show="service == 'chatgpt'" style="display:inline" v-model="display.column_document" />Colonne des images</p>
                <p><b-checkbox v-show="service == 'chatgpt'" style="display:inline" v-model="display.is_images" />Images en entrée</p>
                <p><b-checkbox v-show="service == 'chatgpt'" style="display:inline" v-model="display.is_documents" :disabled="display.web_search" />Documents en entrée</p>
                <p><b-checkbox style="display:inline" v-model="display.return_line" />Retour à la ligne <b-button style="padding: 1px;" variant="link" v-b-tooltip.hover title="Personnaliser le retour à la ligne, par exemple <br /> pour du html"><i class="fas fa-info"></i></b-button></p>
                <p><b-checkbox style="display:inline" v-model="display.temperature" />Température <b-button style="padding: 1px;" variant="link" v-b-tooltip.hover title="Valeur comprise entre 0 et 2. Des valeurs plus élevées comme 0,8 rendront la sortie plus aléatoire, tandis que des valeurs plus faibles comme 0,2 la rendront plus ciblée et déterministe.">
                    <i class="fas fa-info"></i>
                </b-button></p>
                <p><b-checkbox style="display:inline" v-model="display.top_p" />Top P <b-button style="padding: 1px;" variant="link" v-b-tooltip.hover title="Valeur comprise entre 0 et 1. Alternative à la température. Des valeurs élevées rendront la sortie plus aléatoire, tandis que des valeurs faibles la rendront plus ciblée et déterministe.">
                    <i class="fas fa-info"></i>
                </b-button></p>
                Il est recommandé de ne pas utilisé la température et Top p en même temps.
            </b-modal>
            
            <b-container style="margin: 0; padding: 0; max-width: none;">
                <b-row>
                    <b-col :cols="12"  v-if="display.system">
                        Message système <b-button style="padding: 1px;" variant="link" v-b-tooltip.hover title="Message système pour préciser le rôle de ChatGPT, par exemple : Je suis un assistant expert en seo."><i class="fas fa-info"></i></b-button>
                        <textarea_plus ref="system" :columns="columns_data" :height="100"></textarea_plus>
                    </b-col>
                    <b-col :cols="4" v-if="display.get_column_system">Récupérer le message système envoyé
                        <b-input v-model="get_column_system" placeholder="Nom de la colonne" />
                    </b-col>
                    <b-col :cols="4" v-if="display.get_column_prompt">Récupérer le prompt envoyé
                        <b-input v-model="get_column_prompt" placeholder="Nom de la colonne"/>
                    </b-col>
                    <b-col :cols="4" v-if="display.column_document">Colonne de images
                        <b-input v-model="column_document" />
                    </b-col>
                    <b-col :cols="4" style="display:inline" v-if="display.is_images">Images en entrée
                        <b-checkbox v-model="is_images" />
                    </b-col>
                    <b-col :cols="4" style="display:inline" v-if="display.is_documents">Documents en entrée
                        <b-checkbox v-model="is_documents" />
                    </b-col>
                    <b-col v-if="display.return_line" :cols="4">Retour à la ligne <b-button style="padding: 1px;" variant="link" v-b-tooltip.hover title="Personnaliser le retour à la ligne, par exemple <br /> pour du html"><i class="fas fa-info"></i></b-button>
                        <b-input v-model="return_line" />
                    </b-col>
                    <b-col :cols="4" v-if="display.temperature">Température <b-button style="padding: 1px;" variant="link" v-b-tooltip.hover title="Valeur comprise entre 0 et 2. Des valeurs plus élevées comme 0,8 rendront la sortie plus aléatoire, tandis que des valeurs plus faibles comme 0,2 la rendront plus ciblée et déterministe.">
                            <i class="fas fa-info"></i>
                        </b-button>
                        <b-input type="number" :min="0" :max="2" v-model="temperature" :step="0.1" />
                    </b-col>
                    <b-col :cols="4" v-if="display.top_p">Top P <b-button style="padding: 1px;" variant="link" v-b-tooltip.hover title="Valeur comprise entre 0 et 1. Alternative à la température. Des valeurs élevées rendront la sortie plus aléatoire, tandis que des valeurs faibles la rendront plus ciblée et déterministe.">
                            <i class="fas fa-info"></i>
                        </b-button>
                        <b-input type="number" :min="0" :max="1" v-model="top_p" :step="0.1" />
                    </b-col>
                </b-row>
            </b-container>
        </p>

        <p><b>Résultats</b>

            <b-container style="margin: 0; padding: 0; max-width: none;">
                <b-row>
                    <b-col :cols="4">Colonne de résultats
                        <b-input v-model="column_result" />
                    </b-col>
                    <b-col :cols="4">Colonne d'erreurs
                        <b-input v-model="column_error" />
                    </b-col>
                    <b-col v-show="!has_json_schema" :cols="4">Colonne de résultat json<b-button style="padding: 1px;" variant="link" v-b-tooltip.hover title="Extrait et nettoie le premier json du résultat"></b-button>
                        <b-input v-model="column_json" />
                    </b-col>
                </b-row>
            </b-container>

            <p v-show="column_json || has_json_schema">
                Extraire les résultats
                <b-checkbox v-model="split_result" />
            </p>
        </p>

        <p v-if="cost"><b>Estimation des coûts</b><br />
            {{ (cost).toFixed(4) }}$ par ligne ou document <br />
            {{ data.length > 0 ? (cost * data.length).toFixed(4) + "$ pour le premier fichier" : "" }} 
        </p>

    </div>
</template>

<script>
    import uniqueId from "lodash.uniqueid";
    import moment from "moment";
    require('moment/locale/fr');

    import json_schema_editor from "../json_schema_editor.vue";
    import workers_service from "../../services/workers.js"
    import edit_tabulator from "../edit_tabulator.vue";
    import textarea_plus from '../textarea_plus.vue';
	import library from "../../services/library.js";

    var clone = require("clone");
    
    export default {
        name: "chatgpt",
		components: {
            json_schema_editor,
            edit_tabulator,
            textarea_plus
		},
		props: {
            treatment_params: {
                default: false
            },
            files: {
                default: () => []
            },
			data: {
				default: () => [],
            },
			client: {
				default: null
            },
            size: {
                default: 1000
            },
			user_params_config: {
				default: ""
			},
			user_params_test: {
				default: false
			},
			project_uid: {
				default: ""
			},
			step_position: {
				default: 0
			},
            service: {
                default: "chatgpt"
            }
        },
        watch: 
        {
            model: {
                async handler()
                {
                    if (this.list_models_obj[this.model])
                    {
                        var model = this.list_models_obj[this.model];

                        model = JSON.parse(model.data)

                        if (model.params)
                        {
                            if (model.params.prompt_system)
                            {
                                this.display.system = true;

                                await this.$nextTick();

                                var data = this.$refs.system.get_data()
                                if (!data)
                                    this.$refs.system.load(model.params.prompt_system);
                            }
                            if (model.params.prompt_user)
                            {
                                var data = this.$refs.request.get_data()
                                if (!data)
                                    this.$refs.request.load(model.params.prompt_user)
                            }
                        }

                        console.log(model)
                    }
                }
            },
            service: {
                immediate: true,
                async handler()
                {
                    var names = await library.getby_production("chatgpt_train", null, false, false, false);
                    names = names.element;

                    this.list_models = [""];
                    for (var i = 0; i < names.length; i++) {
                        if (names[i].data.includes('"service":"' + this.service + '"') && !this.list_models_obj[names[i].name])
                        {
                            this.list_models.push(names[i].name);
                            this.list_models_obj[names[i].name] = names[i];
                        }
                    }

                    if (this.model && !this.list_models.includes(this.model))
                        this.model = "";

                    if (this.service == "perplexity")
                    {
                        this.display.column_document = false;
                        this.display.is_images = false;
                        this.display.is_documents = false;
                    }

                    this.get_cost();
                }
            },
            user_params_config()
            {
                this.get_cost()
            },
            user_params_test()
            {
                this.get_cost()
            },
            data: {
                deep: true,
                immediate: true,
                handler()
                {
                    if (this.data.length != 0)
                    {
                        this.columns_data = Object.keys(this.data[0]);
                    }
                }
            },
            files: {
                deep: true,
                immediate: true,
                handler()
                {
                    //console.log(this.files);

                    if (this.files.length > 0)
                    {
                        var self = this;
                        var reader = new FileReader();

                        reader.onload = (function (theFile) {
                            return function (e) {
                                if (e.target.result)
                                {
                                    var data = self.$papa.parse(e.target.result, { header: true });
                                    if (data.data && data.data.length > 0)
                                    {
                                        self.columns_data = Object.keys(data.data[0]);
                                    }
                                }
                            };
                        })(this.files[0].file ? this.files[0].file : this.files[0]);

                        reader.readAsText(this.files[0].file ? this.files[0].file : this.files[0]);
                    }
                }
            }
        },
        computed: {
            
        },
		data() {
			return {
                id: uniqueId(""),

                columns_data: [],
                mode: "request",
                list_prepared_requests: [],
                list_models: [],
                list_models_obj: {},
                element: "",
                column_result: "result",
                column_error: "error",
                model: "",
                model_editor_name: "",
                model_editor_version: "",
                model_editor_service: "chatgpt",
                model_editor_is_new: true,
                model_editor_saving: false,
                model_editor_error: "",
                model_editor_loading_models: false,
                model_editor_available_models: [
                ],
                display: {
                    column_document: false,
                    temperature: false,
                    top_p: false,
                    is_images: false,
                    is_documents: false,
                    return_line: false,
                    system: false,
                    web_search: false
                },
                web_search_allowed_domains: "",
                web_search_blocked_domains: "",
                web_search_location_city: "Paris",
                web_search_location_country: "FR",
                web_search_column_sources: "",
                web_search_column_citations: "",
                web_search_strip_citations: false,
                column_document: "",
                temperature: 1,
                top_p: 1,
                is_documents: true,
                is_images: true,
                return_line: "",
                column_json: "",
                cost: 0,
                has_json_schema: false,
                json_schema_column: "",
                split_result: false,
                get_column_system: "",
                get_column_prompt: ""
			};
        },
        methods: {
            async fetch_available_models()
            {
                this.model_editor_loading_models = true;
                this.model_editor_error = "";
                try
                {
                    var formData = new FormData();
                    formData.append("action", "saas_back-openai");
                    formData.append("parameters", JSON.stringify({ type: "list_models" }));
                    var data = await workers_service.test(formData);
                    var list = data.data.json[0].result.data;
                    list.sort((a, b) => (a.created > b.created) ? -1 : 1);
                    this.model_editor_available_models = [];
                    for (var i = 0; i < list.length; i++)
                    {
                        if (list[i].owned_by.startsWith("user") ||
                            list[i].id.startsWith("gpt-3") ||
                            list[i].id.startsWith("gpt-4") ||
                            list[i].id.startsWith("gpt-5") ||
                            list[i].id.startsWith("o") ||
                            list[i].id.startsWith("ft:"))
                        {
                            this.model_editor_available_models.push({
                                value: list[i].id,
                                text: list[i].id + (list[i].created ? " - " + moment(list[i].created * 1000).format("LLL") : "")
                            });
                        }
                    }
                }
                catch(err)
                {
                    this.model_editor_error = "Impossible de récupérer la liste des modèles.";
                }
                finally
                {
                    this.model_editor_loading_models = false;
                }
            },
            async get_cost()
            {
                this.cost = await workers_service.gpt_cost(this.project_uid, [(this.step_position + 1).toString()], this.user_params_test ? this.user_params_config : "");
                console.log(this.cost)
            },
            open_model_editor()
            {
                this.model_editor_error = "";
                this.model_editor_saving = false;
                if (this.model && this.list_models_obj[this.model])
                {
                    var m = JSON.parse(this.list_models_obj[this.model].data);
                    this.model_editor_is_new = false;
                    this.model_editor_name = this.model;
                    this.model_editor_version = m.model || "";
                    this.model_editor_service = m.service || this.service;
                }
                else
                {
                    this.model_editor_is_new = true;
                    this.model_editor_name = "";
                    this.model_editor_version = "";
                    this.model_editor_service = this.service;
                }
                this.$bvModal.show("model_editor" + this.id);
            },
            async save_model(bvModalEvent)
            {
                bvModalEvent.preventDefault();
                this.model_editor_error = "";

                if (!this.model_editor_name.trim())
                {
                    this.model_editor_error = "Le nom est requis.";
                    return;
                }
                if (!this.model_editor_version.trim())
                {
                    this.model_editor_error = "La version ChatGPT est requise.";
                    return;
                }

                this.model_editor_saving = true;

                var existing = this.model_editor_is_new ? null : this.list_models_obj[this.model];
                var existing_data = existing ? JSON.parse(existing.data) : {};

                var data = Object.assign({}, existing_data, {
                    model: this.model_editor_version.trim(),
                    service: this.model_editor_service
                });

                try
                {
                    await library.save(
                        this.model_editor_name.trim(),
                        new Date().toISOString(),
                        data,
                        "chatgpt_train",
                        null
                    );

                    // Rafraichir la liste
                    var names = await library.getby_production("chatgpt_train", null, false, false, false);
                    names = names.element;
                    this.list_models = [""];
                    this.list_models_obj = {};
                    for (var i = 0; i < names.length; i++)
                    {
                        if (names[i].data.includes('"service":"' + this.service + '"') && !this.list_models_obj[names[i].name])
                        {
                            this.list_models.push(names[i].name);
                            this.list_models_obj[names[i].name] = names[i];
                        }
                    }

                    this.model = this.model_editor_name.trim();
                    this.$bvModal.hide("model_editor" + this.id);
                }
                catch(err)
                {
                    this.model_editor_error = "Erreur lors de l'enregistrement.";
                }
                finally
                {
                    this.model_editor_saving = false;
                }
            },
            get_data()
            {
                return this.save()
            },
            save()
            {
                var data = {
                    columns_data: this.columns_data,
                    element: this.mode == "prepared_request" ? this.element : "",
                    mode: this.mode,
                    column_result: this.column_result,
                    column_error: this.column_error,
                    model: this.model,
                    content: this.$refs.request ? this.$refs.request.get_data() : "",
                    display: this.display,
                    column_json: this.column_json,
                    service: this.service,
                    has_json_schema: this.has_json_schema,
                    json_schema_column: this.json_schema_column || "",
                    json_schema: (this.has_json_schema && !this.json_schema_column) ? this.$refs.json_schema_editor.get_data() : null,
                    split_result: this.split_result,
                    system: this.$refs.system ? this.$refs.system.get_data() : "",
                }

                if (this.display.get_column_prompt)
                    data.get_column_prompt = this.get_column_prompt;
                if (this.display.get_column_system)
                    data.get_column_system = this.get_column_system;
                if (this.display.is_documents)
                    data.is_documents = this.is_documents;
                if (this.display.is_images)
                    data.is_images = this.is_images;
                if (this.display.column_document)
                    data.column_document = this.column_document;
                if (this.display.return_line)
                    data.return_line = this.return_line;
                if (this.display.temperature)
                    data.temperature = parseFloat(this.temperature);
                if (this.display.top_p)
                    data.top_p = parseFloat(this.top_p);
                if (this.display.web_search)
                {
                    data.web_search = true;
                    data.web_search_allowed_domains = this.web_search_allowed_domains.split("\n").map(s => s.trim()).filter(Boolean);
                    data.web_search_blocked_domains = this.web_search_blocked_domains.split("\n").map(s => s.trim()).filter(Boolean);
                    data.web_search_location_city = this.web_search_location_city.trim();
                    data.web_search_location_country = this.web_search_location_country.trim().toUpperCase();
                    data.web_search_column_sources = this.web_search_column_sources.trim();
                    data.web_search_column_citations = this.web_search_column_citations.trim();
                    data.web_search_strip_citations = this.web_search_strip_citations;
                }

                return data;
            },
            async load(data)
            {
                var self = this;

                console.log("load " + this.id)
                
                if (!data)
                {
                    return;
                }

                console.log(data)

                this.columns_data = data.columns_data;
                this.element = data.element || "";
                this.mode = data.mode || "request";
                this.column_result = data.column_result;
                this.column_error = data.column_error;
                this.column_json = data.column_json;
                this.model = data.model;
                this.has_json_schema = data.has_json_schema || false;
                this.json_schema_column = data.json_schema_column || "";
                this.split_result = data.split_result || false

                if (data.display)
                {
                    var keys = Object.keys(data.display);
                    for (var i = 0; i < keys.length; i++)
                    {
                        if (data.display[keys[i]])
                        {
                            this.display[keys[i]] = true;
                            if (data.hasOwnProperty(keys[i]))
                                this[keys[i]] = data[keys[i]];
                        }
                    }
                }

                if (data.web_search_allowed_domains && data.web_search_allowed_domains.length)
                    this.web_search_allowed_domains = data.web_search_allowed_domains.join("\n");
                if (data.web_search_blocked_domains && data.web_search_blocked_domains.length)
                    this.web_search_blocked_domains = data.web_search_blocked_domains.join("\n");
                this.web_search_location_city = data.web_search_location_city || "Paris";
                this.web_search_location_country = data.web_search_location_country || "FR";
                this.web_search_column_sources = data.web_search_column_sources || "";
                this.web_search_column_citations = data.web_search_column_citations || "";
                this.web_search_strip_citations = data.web_search_strip_citations || false;
           
                this.$nextTick(() => {
                    if (self.mode == "request")
                    {
                        self.$refs.request.load(data.content)
                    }
                    if (this.display.system == true)
                    {
                        self.$refs.system.load(data.system)
                    }

                    if (self.has_json_schema && !self.json_schema_column && data.json_schema)
                        self.$refs.json_schema_editor.load(data.json_schema)
                })
            },
        },
        async mounted()
        {		
            var names = await library.getby_production("chatgpt", null, false, false, false);
            names = names.element;

            this.list_prepared_requests	= [];
            for (var i = 0; i < names.length; i++) {
                this.list_prepared_requests.push(names[i].name);
            }
        }
    }
</script>

<style scoped>
</style>